<template>
  <div id="pageRoot" class="blind">
    <span class="pageInstruction" style="left: 30px; top: 55px;">
      <p>Tacha el dibujo cuyo nombre no rima.</p>
    </span>
    <span class="pageInstruction" style="left: 30px; top: 95px;">
      <p>Escribe las palabras que riman.</p>
    </span>

    <p class="big" style="left: 30px; top: 160px;">ESPADA</p>
    <p class="big" style="left: 30px; top: 220px;">SERAFÍN</p>
    <p class="big" style="left: 30px; top: 280px;">ESCARPÍN</p>

    <label class="imageRadioButton">
    <input type="radio" name="part1" value="Hormiguero" 
        ref="1-1" 
        v-on:change="saveOption('radios', 1, 1)" 
        :onload="loadOption('radios', 1, 1)"
        />
      <span class="checkmark" style="margin-left: 30px; margin-top: 420px; width: 204px; height: 170px">
        <img class="image" src="/pages/img/blindcas/assets_p18/espada.svg">
      </span>
    </label>
    <label class="imageRadioButton">
    <input type="radio" name="part1" value="Cocinero" 
        ref="1-2" 
        v-on:change="saveOption('radios', 1, 2)" 
        :onload="loadOption('radios', 1, 2)"
        />
      <span class="checkmark" style="margin-left: 260px; margin-top: 420px; width: 204px; height: 170px">
        <img class="image" src="/pages/img/blindcas/assets_p18/serafin.svg">
      </span>
    </label>
    <label class="imageRadioButton">
    <input type="radio" name="part1" value="Pajaro" 
        ref="1-3" 
        v-on:change="saveOption('radios', 1, 3)" 
        :onload="loadOption('radios', 1, 3)"
        />
      <span class="checkmark" style="margin-left: 490px; margin-top: 420px; width: 204px; height: 170px">
        <img class="image" src="/pages/img/blindcas/assets_p18/zapato.svg">
      </span>
    </label>

    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
      class="pageElement"
    />
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
      class="pageElement"
    />
  </div>
</template>
<style scoped>
#inputField01 {
  position: absolute;
  width: 183px;
  left: 30px;
  top: 600px;
}
#inputField02 {
  position: absolute;
  width: 183px;
  left: 260px;
  top: 600px;
}
#inputField03 {
  position: absolute;
  width: 183px;
  left: 490px;
  top: 600px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, group){
        return `${this.$parent.pageID()}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>